import { render, staticRenderFns } from "./InformativoFormatoArquivo.vue?vue&type=template&id=2e13abcf&scoped=true"
import script from "./InformativoFormatoArquivo.vue?vue&type=script&lang=js"
export * from "./InformativoFormatoArquivo.vue?vue&type=script&lang=js"
import style0 from "./InformativoFormatoArquivo.vue?vue&type=style&index=0&id=2e13abcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e13abcf",
  null
  
)

export default component.exports